<ng-container *transloco="let t; prefix: scope">
  @let logo = agent().theme.rectangleLogoImage ?? agent().theme.bannerImage;
  @let background = agent().theme.primaryColour ?? agent().theme.backgroundColour ?? '#fff';

  @if (agent().isBranded && logo) {
    <a [attr.aria-label]="agent().agencyName" [routerLink]="[agent().agencyProfileUrl]">
      <rma-branded-header class="h-12 rounded-t-lg" [background]="background" [logo]="logo" />
    </a>
  } @else {
    <div class="bg-blue-5 h-12 rounded-t-lg" data-id="unbranded-header"></div>
  }

  <button
    type="button"
    class="absolute -top-2 right-0 z-10 flex h-6 w-6 items-center justify-center rounded-full bg-steel-100/70 text-white"
    [attr.aria-label]="t('cardsRow.removeAgent', { name: agent().agentName })"
    (click)="removeAgent.emit()"
    data-id="remove-agent"
  >
    <rma-icon glyph="close" size="extraSmall" />
  </button>

  <div class="flex grow flex-col items-center px-3 pt-3 pb-4">
    <rma-profile-avatar [avatar]="agent().theme.avatarImage" [name]="agent().agentName" [size]="72" />

    <div class="mt-2 flex items-center justify-center gap-1">
      <a class="line-clamp-1 text-center font-semibold no-underline!" [routerLink]="[agent().agentProfileUrl]">{{ agent().agentName }}</a>
      @if (agent().isClaimed) {
        <rma-verified-profile-tick class="shrink-0" data-id="agent-card-claimed" />
      }
    </div>

    @if (agent().canContact) {
      <div class="mt-auto hidden w-full flex-col gap-2 pt-3 md:flex">
        @if (contactUrl(); as contactUrl) {
          <a
            class="w-full"
            [routerLink]="contactUrl"
            [queryParams]="appraisalUrlParams | appendReturnUrlParams"
            mat-flat-button
            color="primary"
            data-id="agent-card-appraisal"
          >
            <rma-icon glyph="mail" matButtonIcon />
            <span class="truncate">{{ t('requestAppraisal') }}</span>
          </a>
        }

        <div class="flex w-full flex-wrap gap-2">
          @if (contactUrl(); as contactUrl) {
            <a
              class="flex-1"
              [routerLink]="contactUrl"
              [queryParams]="enquireUrlParams | appendReturnUrlParams"
              mat-stroked-button
              color="primary"
              data-id="agent-card-enquire"
            >
              <rma-icon glyph="mail" matButtonIcon />
              {{ t('enquire') }}
            </a>
          }
          @if (agent().mobile; as mobile) {
            <rma-agent-phone-link
              class="flex-1"
              [agentCode]="agent().agentCode"
              [phone]="mobile"
              [customLabel]="t('call')"
              [revealAction]="phoneAnalytics().revealAction"
              [revealLabel]="phoneAnalytics().revealLabel"
              [callMadeAction]="phoneAnalytics().callMadeAction"
              [callMadeLabel]="phoneAnalytics().callMadeLabel"
              [trixelRevealCategory]="phoneAnalytics().trixelRevealCategory"
              [trixelCallCategory]="phoneAnalytics().trixelCallCategory"
              data-id="agent-card-call"
            />
          }
        </div>
      </div>
    }
  </div>
</ng-container>
